import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const fetchStories = createAsyncThunk(
    'fetchStories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('https://allof.deprakoso.com/api/keeus/story'); // Update this URL with your actual endpoint
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export { fetchStories };
